module.exports = __webpack_public_path__ + "static/dm-ebd1283544c0efa12c0a426c532551da.svg";